/* global axios */
import ApiClient from './ApiClient';

class ErpContactsAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  show(conversationId) {
    return axios.get(`${this.url}/${conversationId}/erp_contact`);
  }

  sync(conversationId, force = false) {
    return axios.post(`${this.url}/${conversationId}/erp_contact/sync`, {
      force,
    });
  }

  invoices(conversationId, externalClientId) {
    return axios.get(`${this.url}/${conversationId}/erp_contact/invoices`, {
      params: { external_client_id: externalClientId },
    });
  }

  invoiceDescription(conversationId, externalClientId, invoiceId) {
    return axios.get(
      `${this.url}/${conversationId}/erp_contact/invoice_description`,
      {
        params: {
          external_client_id: externalClientId,
          invoice_id: invoiceId,
        },
      }
    );
  }

  createPaymentPromise(conversationId, payload) {
    return axios.post(
      `${this.url}/${conversationId}/erp_contact/payment_promise`,
      payload
    );
  }
}

export default new ErpContactsAPI();
